import FreeBusyType from './FreeBusyType';

/**
 * Ranking used for merging multiple free busy slots, sorted from less to most severe.
 */
const FreeBusyRanking: FreeBusyType[] = [
    FreeBusyType.Loading,
    FreeBusyType.NoData,
    FreeBusyType.Free,
    FreeBusyType.WorkingElsewhere,
    FreeBusyType.Tentative,
    FreeBusyType.Busy,
    FreeBusyType.OOF,
];

export default FreeBusyRanking;
